<template>
    <router-link
        :to="{ name: currentDepartment?.type === DepartmentType.Educate ? 'certificate' : 'employ-dashboard' }"
        class="main-header__inner__left__wrap__logo-link__mobile"
    >
        <img
            class="main-header__inner__left__wrap__logo-link__mobile__logo"
            src="/images/falagrett-c-white.svg"
            alt="Falagrett"
        />
    </router-link>

    <div class="toggler" :class="{ 'toggler--active': isMenuToggled }" @click="toggleMenu">
        <span class="toggler__line"></span>
        <span class="toggler__line"></span>
        <span class="toggler__line"></span>
    </div>

    <div v-if="isMenuToggled" class="mobile-nav" :class="{ 'mobile-nav--active': isMenuToggled }">
        <div class="mobile-nav__nav">
            <!-- <ul v-if="currentDepartment && (isCertifier || isEmployAdmin)" class="mobile-nav__list">
                <template v-if="currentDepartment?.type === DepartmentType.Educate">
                    <li class="mobile-nav__list__item">
                        <router-link :to="{ name: 'certificate' }" class="btn btn--cta"> Alla certifikat </router-link>
                    </li>
                    <li class="mobile-nav__list__item">
                        <router-link :to="{ name: 'create-certificate' }" class="btn btn--cta">
                            Skapa certifikat
                        </router-link>
                    </li>
                </template>
            </ul> -->

            <header-drop :is-open="isOpen" @is-open="handleIsOpen" />
        </div>
    </div>
</template>

<script>
    import { computed } from 'vue';
    import { useStore } from 'vuex';
    import router from '../Routes/RouterIndex';
    import HeaderDrop from '@components/Dropdown/HeaderDrop';
    import { DepartmentType } from '@enums/DepartmentType';

    export default {
        components: {
            HeaderDrop,
        },
        setup() {
            const store = useStore();

            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);
            const isMenuToggled = computed(() => store.getters['GlobalStore/GET_MOBILE_TOGGLER']);
            const isOpen = computed(() => store.getters['GlobalStore/getHeaderDropdown']);

            const isEmployAdmin = computed(() => store.getters['UserStore/CAN_USER']('employ.*'));
            const isCertifier = computed(() => store.getters['UserStore/CAN_USER']('certificate.*'));

            const handleIsOpen = () => store.commit('GlobalStore/SET_HEADER_DROPDOWN');

            const toggleMenu = () => {
                document.body.classList.toggle('no-scroll');
                store.commit('GlobalStore/TOGGLE_MOBILE_NAV');
            };

            router.afterEach(() => {
                if (isMenuToggled.value) {
                    store.commit('GlobalStore/TOGGLE_MOBILE_NAV');
                    document.body.classList.remove('no-scroll');
                }
            });

            return {
                currentDepartment,
                isMenuToggled,
                isOpen,
                isEmployAdmin,
                isCertifier,
                handleIsOpen,
                toggleMenu,
                DepartmentType,
            };
        },
    };
</script>
